
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { List, Toast } from 'vant';
import { getList, workType } from '../api';
import SearchBar from '@/components/next/SearchBar.vue';
import Item from './Item.vue';
import { inAppAlertLogin } from '@/common/ts/common';
import { isWeiXin } from '@/common/ts/common';
Vue.use(List);
@Component({
  components: {
    SearchBar,
    Item,
  },
})
export default class VoteList extends Vue {
  @Prop({ default: 1 }) id!: number;
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  placeholder: string = '请输入名称进行搜索';
  inputText: string = '';
  voteList: any[] = [];
  word = '';
  show: boolean = true;
  @Watch('id')
  idChang() {
    this.clear();
  }
  created() {
    // Toast.loading({
    //   duration: 0,
    //   forbidClick: true,
    // });
    // this.onGetVoteList();
  }
  handleSearch() {
    this.resetState();
  }
  resetState() {
    this.loading = false;
    this.finished = false;
    this.voteList = [];
    this.page = 1;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  clear() {
    this.resetState();
  }
  onSearch() {
    this.resetState();
  }
  userInputChange(text: string) {
    this.inputText = text;
  }
  onLoad() {
    getList(this.page, this.inputText, this.id).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.voteList = [...this.voteList, ...res.data];
    }
    this.loading = false;
  }
  // async onGetVoteList() {
  //   this.loading = true;
  //   try {
  //     const res = await getList(this.page, this.inputText, this.id);
  //     Toast.clear();
  //     if (!res.data.length) {
  //       this.finished = true;
  //       return;
  //     }
  //     this.voteList = [...this.voteList, ...res.data];
  //   } catch (e) {
  //     console.log('请求出错', e);
  //     // this.finished = true;
  //   }
  //   this.loading = false;
  //   if (this.loading || this.finished) {
  //     console.log('列表全部加载完成或加载中');
  //     return;
  //   }
  //   this.page++;
  // }

  clickItem(item: any) {
    this.$router.push({
      path: 'detail',
      query: {
        id: item.id,
        tb: item.tb,
      },
    });
  }

  // 点击充值
  handleTopup() {
    if (!window.udid && !isWeiXin()) {
      Toast('请在上游新闻app参与');
      return;
    }

    // 在app里没有登陆的时候
    if (!isWeiXin()) {
      if (!window.gettoken() || window.gettoken() === 'null') {
        inAppAlertLogin();
        return;
      }
    }

    this.$router.push({
      path: 'user/top-up',
    });
  }

  votSuccess(data: any) {
    this.voteList.forEach((item) => {
      if (item.id === data.id) {
        item.votes = data.num;
      }
    });
  }
}
